var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { html } from 'lit';
import { property } from 'lit/decorators.js';
import { ifDefined } from 'lit/directives/if-defined.js';
import { BlocksElement } from '../../BlocksElement';
import styles from '../icon.styles';
/**
 * List component
 * @csspart base- The component's base wrapper
 */
export class BlocksIconList extends BlocksElement {
    static { this.styles = styles; }
    connectedCallback() {
        super.connectedCallback();
        this.classList.add('cat-icon');
    }
    render() {
        const componentClassName = this.componentClassNames('cat-c-icon', {
            'cat-c-icon--sm': this.size === 'sm',
            'cat-c-icon--lg': this.size === 'lg',
            'cat-c-icon--xl': this.size === 'xl',
            'cat-c-icon--content-strong': this.color === 'content-strong',
            'cat-c-icon--knockout': this.color === 'knockout',
            'cat-c-icon--knockout-brand': this.color === 'knockout-brand',
            'cat-c-icon--information': this.color === 'information',
            'cat-c-icon--success': this.color === 'success',
            'cat-c-icon--warning': this.color === 'warning',
            'cat-c-icon--error': this.color === 'error'
        });
        return html `
      <span part="base" class="${componentClassName}" role="presentation">
        <svg
          aria-hidden="${!this.iconTitle}"
          aria-label="${ifDefined(this.iconTitle)}"
          role="${this.iconTitle && 'img'}"
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M2.63488 5.75691C3.06587 5.75691 3.41526 5.40752 3.41526 4.97652C3.41526 4.54553 3.06587 4.19614 2.63488 4.19614C2.20388 4.19614 1.85449 4.54553 1.85449 4.97652C1.85449 5.40752 2.20388 5.75691 2.63488 5.75691Z"
          />
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M2.63488 4.94614C2.6181 4.94614 2.60449 4.95974 2.60449 4.97652C2.60449 4.9933 2.6181 5.00691 2.63488 5.00691C2.65166 5.00691 2.66526 4.9933 2.66526 4.97652C2.66526 4.95974 2.65166 4.94614 2.63488 4.94614ZM1.10449 4.97652C1.10449 4.13131 1.78967 3.44614 2.63488 3.44614C3.48008 3.44614 4.16526 4.13131 4.16526 4.97652C4.16526 5.82173 3.48008 6.50691 2.63488 6.50691C1.78967 6.50691 1.10449 5.82173 1.10449 4.97652Z"
          />
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M7.34766 4.97653C7.34766 4.56232 7.68344 4.22653 8.09766 4.22653H22.1446C22.5588 4.22653 22.8946 4.56232 22.8946 4.97653C22.8946 5.39075 22.5588 5.72653 22.1446 5.72653H8.09766C7.68344 5.72653 7.34766 5.39075 7.34766 4.97653Z"
          />
          <path
            d="M2.63488 12.7804C3.06587 12.7804 3.41526 12.431 3.41526 12C3.41526 11.569 3.06587 11.2196 2.63488 11.2196C2.20388 11.2196 1.85449 11.569 1.85449 12C1.85449 12.431 2.20388 12.7804 2.63488 12.7804Z"
          />
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M2.63488 11.9696C2.6181 11.9696 2.60449 11.9832 2.60449 12C2.60449 12.0168 2.6181 12.0304 2.63488 12.0304C2.65166 12.0304 2.66526 12.0168 2.66526 12C2.66526 11.9832 2.65166 11.9696 2.63488 11.9696ZM1.10449 12C1.10449 11.1548 1.78967 10.4696 2.63488 10.4696C3.48008 10.4696 4.16526 11.1548 4.16526 12C4.16526 12.8452 3.48008 13.5304 2.63488 13.5304C1.78967 13.5304 1.10449 12.8452 1.10449 12Z"
          />
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M7.34766 12C7.34766 11.5858 7.68344 11.25 8.09766 11.25H22.1446C22.5588 11.25 22.8946 11.5858 22.8946 12C22.8946 12.4142 22.5588 12.75 22.1446 12.75H8.09766C7.68344 12.75 7.34766 12.4142 7.34766 12Z"
          />
          <path
            d="M2.63488 19.8038C3.06587 19.8038 3.41526 19.4545 3.41526 19.0235C3.41526 18.5925 3.06587 18.2431 2.63488 18.2431C2.20388 18.2431 1.85449 18.5925 1.85449 19.0235C1.85449 19.4545 2.20388 19.8038 2.63488 19.8038Z"
          />
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M2.63488 18.9931C2.6181 18.9931 2.60449 19.0067 2.60449 19.0235C2.60449 19.0402 2.6181 19.0538 2.63488 19.0538C2.65166 19.0538 2.66526 19.0402 2.66526 19.0235C2.66526 19.0067 2.65166 18.9931 2.63488 18.9931ZM1.10449 19.0235C1.10449 18.1782 1.78967 17.4931 2.63488 17.4931C3.48008 17.4931 4.16526 18.1782 4.16526 19.0235C4.16526 19.8687 3.48008 20.5538 2.63488 20.5538C1.78967 20.5538 1.10449 19.8687 1.10449 19.0235Z"
          />
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M7.34766 19.0235C7.34766 18.6093 7.68344 18.2735 8.09766 18.2735H22.1446C22.5588 18.2735 22.8946 18.6093 22.8946 19.0235C22.8946 19.4377 22.5588 19.7735 22.1446 19.7735H8.09766C7.68344 19.7735 7.34766 19.4377 7.34766 19.0235Z"
          />
        </svg>
      </span>
    `;
    }
}
__decorate([
    property({ type: String })
], BlocksIconList.prototype, "color", void 0);
__decorate([
    property({ type: String })
], BlocksIconList.prototype, "iconTitle", void 0);
__decorate([
    property({ type: String })
], BlocksIconList.prototype, "size", void 0);
if (customElements.get('cat-icon-list') === undefined) {
    customElements.define('cat-icon-list', BlocksIconList);
}
